import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IScheduleShift, IClientDocument, IJobDocument } from "../../../models"
import AddShiftTemplateDialog from "../add_shift_template/AddShiftTemplateDialog"
interface IProps {
  errorText: string
  shiftTemplateHierarchyId: string
  shiftTemplates: IScheduleShift[]
  handleChange(shiftTemplates: IScheduleShift[]): void
  requireOneItem?: boolean
  scheduleJob: IJobDocument
  scheduleClient: IClientDocument
}
interface IState {
  shiftTemplates: IScheduleShift[]
  openAddShiftTemplateDialog: boolean
  editShiftTemplate: IScheduleShift
}

export default class ShiftTemplatesChip extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      shiftTemplates: props.shiftTemplates,
      openAddShiftTemplateDialog: props.requireOneItem ? true : false,
      editShiftTemplate: null,
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ shiftTemplates: nextProps.shiftTemplates })
  }

  handleDelete(shiftTemplateItem) {
    let shiftTemplates = this.state.shiftTemplates.slice()
    shiftTemplates = shiftTemplates.filter((item) => item.Id !== shiftTemplateItem.Id)
    this.setState({ shiftTemplates }, () =>
      this.props.handleChange && this.props.handleChange(shiftTemplates)
    )
  }

  handleAdd(shiftTemplateItem) {
    const shiftTemplates = this.state.shiftTemplates.slice()
    shiftTemplates.push(shiftTemplateItem)
    this.setState({ shiftTemplates, openAddShiftTemplateDialog: false, editShiftTemplate: null }, () => {
      this.props.handleChange && this.props.handleChange(shiftTemplates)
    })
  }

  handleUpdate(shiftTemplateItem) {
    const shiftTemplates = this.state.shiftTemplates.slice()
    const indexOf = this.state.shiftTemplates.indexOf(this.state.editShiftTemplate)
    shiftTemplates[indexOf] = shiftTemplateItem
    this.setState({ shiftTemplates, openAddShiftTemplateDialog: false, editShiftTemplate: null }, () => {
      this.props.handleChange && this.props.handleChange(shiftTemplates)
    })
  }

  render() {
    return (
      <div style={{ position: "relative" }}>
        <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13, marginLeft: 5 }}>{this.props.requireOneItem ? strings.Shift : strings.Shifts}</span>
        <span style={{ color: "rgb(244, 67, 54)", fontSize: 12, marginLeft: 20 }}>{this.props.errorText}</span>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: -7 }}>
          {this.state.shiftTemplates.filter((item) => !item.Deleted).map((item, index) =>
            <Chip
              data-intercom-target={"Shift-Chip"}
              style={{ marginTop: 10, marginRight: 5, height: 35 }}
              key={index}
              onRequestDelete={() => this.handleDelete(item)}
              onClick={() => this.setState({ openAddShiftTemplateDialog: true, editShiftTemplate: item })}
            >
              {item.Name}
            </Chip>
          )}
          {((this.props.requireOneItem && this.state.shiftTemplates.length < 1) || !this.props.requireOneItem) &&
            <IconButton data-intercom-target={"Shift-AddShift-Btn-OpenAddShiftTemplateDialog"} style={{ height: 33, marginTop: 2, display: "inline-block" }} onTouchTap={() => this.setState({ openAddShiftTemplateDialog: true, editShiftTemplate: null })}>
              <FontIcon className="fa fa-plus-circle" />
            </IconButton>
          }
        </div>
        {this.state.openAddShiftTemplateDialog &&
          <AddShiftTemplateDialog
            editShiftTemplate={this.state.editShiftTemplate}
            allowChangeHierarchyForEdit
            hierarchyId={this.props.shiftTemplateHierarchyId}
            handleClose={() => this.setState({ openAddShiftTemplateDialog: false, editShiftTemplate: null })}
            handleAdd={this.handleAdd}
            handleUpdate={this.handleUpdate}
            scheduleJob={this.props.scheduleJob}
            scheduleClient={this.props.scheduleClient}
          />
        }
      </div>
    )
  }
}